import Vue from 'vue';
import VModal from 'vue-js-modal';
import * as $ from 'jquery';
import * as jQuery from 'jquery';
import BootstrapVue from 'bootstrap-vue';
import fontawesome from '@fortawesome/fontawesome';
import faCaretDown from '@fortawesome/fontawesome-free-solid/faCaretDown';
import faCaretRight from '@fortawesome/fontawesome-free-solid/faCaretRight';
import VueMatomo from 'vue-matomo';
import App from './App.vue';
import router from './router';
import store from './store/store';
import UtilPlugin from './utils/util';
// import './registerServiceWorker';

import VueDatePicker from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css'; 
Vue.use(VueDatePicker);
Vue.use(VueDatePicker, {
  lang: 'en'
});

fontawesome.library.add(faCaretDown);
fontawesome.library.add(faCaretRight);

const VueCarousel = require('vue-carousel');

Vue.use(VModal);
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

Vue.use(VueCarousel);
Vue.use(UtilPlugin);
Vue.use(BootstrapVue);
Vue.use(VueMatomo, {
  host: 'https://tcdh01.uni-trier.de/piwik',
  siteId: 26,
  router: router,
  requireConsens: true,
  trackInitialView: true,
});
Vue.config.productionTip = false;

const v = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

(<any> window).vueInstance = v;
